import React from 'react';
import { version } from 'config';

const Footer = () => (
  <footer className="tw-absolute tw-bottom-0 tw-w-full">
    <div className="tw-flex tw-flex-wrap tw-justify-between tw-text-center tw-text-[0.8333rem] tw-mt-6 tw-mb-4">
      <div>
        <p className="tw-mb-0 tw-text-[#748194]">
          Developed by IT department - Pebsteel Buildings Co. Ltd.
          <span className="tw-hidden sm:tw-inline-block">| </span>
          <br className="sm:tw-hidden" /> 2019 &copy;{' '}
          <a href="https://pebsteel.com">Pebsteel</a>
        </p>
      </div>
      <div>
        <p className="tw-mb-0 tw-text-[#748194]">{version}</p>
      </div>
    </div>
  </footer>
);

export default Footer;
